<template>
  <v-container fluid>
      <v-layout row wrap>    
        <v-flex sm6 xs12 class="pa-3">
            <v-form>
                <v-text-field
                    label="Nombre"
                    v-model="entrada.nombre"
                    ></v-text-field>
                <v-text-field
                    label="Monto"
                    v-model="entrada.monto"
                    type="number"
                    ></v-text-field>
                <v-text-field
                    label="Cuotas"
                    v-model="entrada.cuotas"
                    type="number"
                    ></v-text-field>
                <v-select
                    :items="categorias"
                    v-model="entrada.categoria"
                    label="Categoría"
                    single-line
                    ></v-select>
                
                <v-btn @click="guardar" color="primary">Guardar</v-btn>
            </v-form>
        </v-flex>
        <v-flex sm6 xs12 class="pa-3">
            <v-list two-line>
                <template v-for="(item, index) in ultimos_gastos">
                    <v-list-tile avatar  :key="item.title">
                        <v-list-tile-avatar>
                            <v-icon v-html="item.icono"></v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title v-html="item.title"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
        </v-flex>
      </v-layout>
  </v-container>
</template>
<script>
const firebase = require("firebase");
// Required for side-effects
require("firebase/firestore");

firebase.initializeApp({
  apiKey: 'AIzaSyCVpTRTEJqceITrqekSey3HFFyZbBqSGJ8',
  //authDomain: 'localhost',
  projectId: 'planificador-b9d89'
});


var db = firebase.firestore();

export default {
  data() {
    return {
      categorias: ["Comida", "Super", "Juegos", "Otros"],
      entrada: {
        cuotas: 1
      },
      ultimos_gastos: []
    
    };
  },
  mounted(){
      this.traerHistorial()
      this.$emit('setTitulo',"Gastos")
  },
  methods: {
    guardar() {
        const vm = this
        db.collection("gastos").add(vm.getEntrada())
        .then(function(docRef) {
            vm.resetearEntrada();
        })
        .catch(function(error) {
            alert("Ocurrio un error")
        });
    },
    getEntrada(){
        this.entrada.fecha = new Date()
        return this.entrada
    },
    resetearEntrada(){
        this.entrada = {
            cuotas: 1
        }
    },
    traerHistorial(){
        const vm = this
        db.collection("gastos").orderBy("fecha","desc").limit(5)
            .onSnapshot(querySnapshot => {
                vm.ultimos_gastos = []
                querySnapshot.forEach(doc => vm.ultimos_gastos.push(
                    vm.formatItem(doc.data())
                ))
            });
    },
    formatItem(data){
        return {
            title: this.formatPrice(data.monto),
            subtitle: this.getSubTitle(data),
            icono: this.getIcono(data.categoria)
        }
    },
    getSubTitle(data){
        let fecha = this.$moment(data.fecha).format("dddd, MMMM Do YYYY")
        return `<span class='text--primary'>${this.getNombre(data)}</span> &mdash; ${fecha}`
    },
    getNombre(data){
        return data.nombre || data.categoria
    },
    formatPrice(value) {
        let val = value.replace('.', ',')
        let formateado = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return `$ ${formateado}`
    },
    getIcono(cat){
        switch(cat){
            case "Super":
                return "shopping_cart"
            case "Comida":
                return "restaurant"
            case "Juegos":
                return "grade"            
            default:
                return "toys"
        }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Gastos.vue